import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=10fbdea6"
import script from "./Door.vue?vue&type=script&lang=ts"
export * from "./Door.vue?vue&type=script&lang=ts"
import style0 from "./Door.vue?vue&type=style&index=0&id=10fbdea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports